var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Switch } from '@headlessui/react';
import { createSelector } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store';
import { updateAllowPlayAudioNotification } from '../../../store/slices/roomSettingsSlice';
const allowPlayAudioNotificationSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.allowPlayAudioNotification);
$RefreshReg$(_react_refresh_temp_1, "allowPlayAudioNotificationSelector$createSelector");
const Notification = () => {
    _react_refresh_temp_3();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const allowPlayAudioNotification = useAppSelector(allowPlayAudioNotificationSelector);
    const toggleAudioNotification = () => {
        dispatch(updateAllowPlayAudioNotification(!allowPlayAudioNotification));
    };
    const render = () => {
        return (_jsx(Switch.Group, { children: _jsxs("div", { className: "flex items-center justify-between mb-2", children: [_jsx(Switch.Label, { className: "pr-4 w-full dark:text-darkText ltr:text-left rtl:text-right", children: t('header.room-settings.allow-audio-notification') }), _jsx(Switch, { checked: allowPlayAudioNotification, onChange: toggleAudioNotification, className: `${allowPlayAudioNotification
                            ? 'bg-primaryColor dark:bg-darkSecondary2'
                            : 'bg-gray-200 dark:bg-secondaryColor'} relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2`, children: _jsx("span", { className: `${allowPlayAudioNotification
                                ? 'ltr:translate-x-6 rtl:-translate-x-6'
                                : 'ltr:translate-x-1 rtl:translate-x-0'} inline-block w-4 h-4 transform bg-white rounded-full transition-transform` }) })] }) }));
    };
    return _jsx("div", { className: "mt-2", children: render() });
};
_react_refresh_temp_2 = Notification;
$RefreshReg$(_react_refresh_temp_2, "Notification");
_react_refresh_temp_3(Notification, "UxQEH8Y8AKEIFc2V9L9WozPyMzA=", false, () => [useAppDispatch, useTranslation, useAppSelector]);
export default Notification;
